export const green = "rgb(40, 167, 69)";
export const white = "white";
export const black = "black";
export const lightGreen = "rgb(2, 236, 136)";
export const drakBlue = "rgb(5, 56, 107)";
export const drakGreen = "green";
export const gray = "rgb(136, 136, 136)";
export const lightGray = "rgb(244 244 244)";
